import type {ReactNode} from 'react';
import type {
  PortalPopoutTriggerProps,
  PopoutOptions,
} from './PortalPopoutReduxContext';
import {usePortalPopoutManager} from './hooks/usePortalPopoutManager';

interface PortalPopoutTriggerWithOptionsProps extends PortalPopoutTriggerProps {
  options?: PopoutOptions;
}

// ----------------------------
// PortalPopoutTrigger
// ----------------------------
export const PortalPopoutTrigger = ({
  popoutId,
  children,
  options,
}: PortalPopoutTriggerWithOptionsProps): ReactNode => {
  const {openPopout, closePopout, focusPopout, isPopoutOpen, getPopout} =
    usePortalPopoutManager();

  const isOpen = isPopoutOpen(popoutId);
  const popout = getPopout(popoutId);
  const isReady = popout?.isReady ?? false;

  const open = () => openPopout(popoutId, options);
  const close = () => closePopout(popoutId);
  const toggle = () => (isOpen ? close() : open());
  const focus = () => focusPopout(popoutId);

  return children({
    isOpen,
    isReady,
    open,
    close,
    toggle,
    focus,
  });
};

export default PortalPopoutTrigger;
